<template>
    <div class="login-bg">
        <div class="login-left">
            <img
                v-if="$store.state.clientele.imageAddress"
                :src="$store.state.clientele.imageAddress"
                alt=""
            />
            <img v-else src="../../../static/images/logo-white.png" alt="" />
            <div class="clienteleName">
                {{ $store.state.clientele.clienteleName }}
            </div>
            <div class="login-copyright">Copyright 2019 长春市把手科技有限公司</div>
            <div class="login-info">
                <div class="login-info-title">
                    {{ $store.state.clientele.displayName }}
                </div>
                <div class="login-info-text">{{ $store.state.clientele.slogan }}</div>
            </div>
        </div>
        <div class="login-right">
            <div class="login-box">
                <h2>{{ isQQOrWeiXin == '1' ? '注册' : '绑定' }}</h2>
                <a-form :form="form" v-if="isQQOrWeiXin == '1'">
                    <!--<a-form-item
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input class="border-bottom" ref="username"
                     v-decorator="['username',{rules: [{ required: true, message: '请输入用户名' }]}]"
                     placeholder="请输入用户名" autocomplete="off"
            />
          </a-form-item>-->
                    <!-- <a-form-item
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input class="border-bottom" ref="invitingCode"
                     v-decorator="['invitingCode',{rules: [{ required: true, message: '请输入邀请码' },{ pattern: '^[A-Za-z0-9]{6}$', message: '请输入数字和字母的6位邀请码组合'}]}]"
                     placeholder="请输入邀请码" autocomplete="off"
            />
          </a-form-item> -->
                    <a-form-item :wrapper-col="formItemLayout.wrapperCol">
                        <a-input
                            class="border-bottom"
                            ref="phone"
                            v-decorator="[
                                'phone',
                                { rules: [{ required: true, message: '请输入手机号' }] },
                            ]"
                            placeholder="请输入手机号"
                            autocomplete="off"
                        />
                    </a-form-item>
                    <a-form-item class="form-item" :wrapper-col="formItemLayout.wrapperCol">
                        <a-input
                            class="border-bottom"
                            ref="picCode"
                            v-decorator="[
                                'picCode',
                                { rules: [{ required: false, message: '请输入图形验证码' }] },
                            ]"
                            placeholder="请输入图形验证码"
                            autocomplete="off"
                        />
                        <s-identify
                            :identifyCode="identifyCode"
                            @click.native="refreshCode"
                            class="identifyCode"
                        ></s-identify>
                    </a-form-item>
                    <a-form-item class="form-item" :wrapper-col="formItemLayout.wrapperCol">
                        <a-input
                            class="border-bottom"
                            ref="phoneCode"
                            v-decorator="[
                                'phoneCode',
                                { rules: [{ required: true, message: '请输入短信验证码' }] },
                            ]"
                            placeholder="请输入短信验证码"
                            autocomplete="off"
                        />
                        <a-button
                            type="primary"
                            size="small"
                            @click="getPhoneCode"
                            :disabled="disabled"
                        >
                            获取验证码
                        </a-button>
                    </a-form-item>
                    <a-form-item :wrapper-col="formItemLayout.wrapperCol">
                        <a-input
                            class="border-bottom"
                            ref="password"
                            type="password"
                            v-decorator="[
                                'password',
                                {
                                    rules: [
                                        { required: true, message: '请输入密码' },
                                        {
                                            pattern: regNumberEndLetter,
                                            message: '请输入数字或字母',
                                        },
                                    ],
                                },
                            ]"
                            placeholder="请输入密码"
                            autocomplete="new-password"
                        />
                    </a-form-item>
                    <a-form-item :wrapper-col="formItemLayout.wrapperCol">
                        <a-input
                            class="border-bottom"
                            ref="confirmPassword"
                            type="password"
                            v-decorator="[
                                'confirmPassword',
                                {
                                    rules: [
                                        { required: true, message: '请确认密码' },
                                        { validator: this.checkContent.bind(this) },
                                    ],
                                },
                            ]"
                            placeholder="请确认密码"
                            autocomplete="new-password"
                        />
                    </a-form-item>

                    <div style="float: right; margin-bottom: 30px">
                        <a-checkbox :checked="checked" @change="onChange" />
                        我已阅读并同意
                        <span
                            @click="showModal"
                            style="cursor: pointer; color: #5867dd; text-decoration: underline"
                        >
                            用户协议</span
                        >
                    </div>

                    <a-form-item
                        class="margin-top-30"
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                    >
                        <a-button type="default" class="my-btn" @click="toLogin">
                            已有账号，去登录
                        </a-button>
                        <a-button type="primary" class="my-btn fr" @click="check">
                            注册并登录
                        </a-button>
                    </a-form-item>
                </a-form>

                <a-form :form="form" v-if="isQQOrWeiXin == '2'">
                    <a-form-item :wrapper-col="formItemLayout.wrapperCol">
                        <a-input
                            v-if="loginStatus == '0'"
                            ref="phone"
                            class="border-bottom"
                            v-decorator="[
                                'phone',
                                { rules: [{ required: true, message: '请输入手机号' }] },
                            ]"
                            placeholder="请输入手机号"
                            autocomplete="off"
                        />

                        <a-config-provider :locale="zhCN">
                            <a-select
                                v-if="loginStatus == '2'"
                                ref="phone"
                                v-decorator="[
                                    'phone',
                                    { rules: [{ required: true, message: '请选择手机号' }] },
                                ]"
                                placeholder="请选择手机号"
                                :options="phoneOptions"
                            />
                        </a-config-provider>
                    </a-form-item>
                    <a-form-item
                        class="form-item"
                        v-if="loginStatus == '0'"
                        :wrapper-col="formItemLayout.wrapperCol"
                    >
                        <a-input
                            class="border-bottom"
                            ref="phoneCode"
                            v-decorator="[
                                'phoneCode',
                                { rules: [{ required: true, message: '请输入短信验证码' }] },
                            ]"
                            placeholder="请输入短信验证码"
                            autocomplete="off"
                        />
                        <a-button
                            type="primary"
                            size="small"
                            @click="getPhoneCodeWeiXin"
                            :disabled="disabled"
                        >
                            获取验证码
                        </a-button>
                    </a-form-item>
                    <a-form-item
                        class="margin-top-30"
                        :label-col="formItemLayout.labelCol"
                        :wrapper-col="formItemLayout.wrapperCol"
                    >
                        <a-button type="default" class="my-btn" @click="toLogin">
                            已有账号，去登录
                        </a-button>
                        <a-button type="primary" class="my-btn fr" @click="bindAndLogin">
                            绑定并登录
                        </a-button>
                    </a-form-item>
                </a-form>
            </div>
        </div>

        <a-modal
            class="modal"
            title="用户协议"
            v-model="visible"
            @ok="handleOk"
            okText="确定"
            cancelText="取消"
            width="700px"
        >
            <div class="title-item">用户协议</div>
            <div class="cont">
                <p>
                    感谢您使用把手科技的产品和服务。本协议是用户（包括注册用户及未注册的访客）以注册、访问或浏览方式使用把手科技的产品与服务时与把手科技有限公司签署的协议。为更好地使用把手科技的产品与服务，您需阅读、理解本协议的所有条款，包括“服务条款”、“隐私条款”、“免责声明”和“版权声明”，并同意受其约束。若您不同意本协议，请勿使用把手科技的产品与服务。
                </p>
            </div>
            <div class="title-item-item">服务条款</div>
            <div class="cont">
                <p>
                    1．您在接受本协议之后，设置的帐号、密码是您用以登录把手科技产品，接受把手科技服务持有的身份识别凭证。
                </p>
                <p>
                    2．您对录入、上传、提交及发表的内容和信息拥有所有权，您的上述行为视为同意授予把手科技无须取得您和他人同意、无需另行通知或补偿您或他人即可使用、复制、修改、传播、发表、加工您通过把手科技产品与服务提供的信息和内容的权利。
                </p>
                <p>
                    3．因为您填写的信息将会对把手科技产品和服务的计算和分析结果带来一定影响，您需承诺提供信息和数据的真实性。
                </p>
                <p>
                    4．如果把手科技认为您的账户或行为可能违反了本协议或法律，或对把手科技产品和服务使用不当，把手科技将保留限制、暂停或终止您帐户的权利。
                </p>
                <p>
                    5．您不得利用把手科技的产品与服务发表、传播、储存危害国家安全、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容。
                </p>
                <p>
                    6．您不得利用把手科技的产品与服务发表、传播、储存侵害他人财产所有权、知识产权、人身权利等合法权利的内容。
                </p>
                <p>
                    7．未经授权，您不得收集、使用、复制、交易任何把手科技产品与服务上的内容、信息或数据。
                </p>
                <p>
                    8．您不得利用把手科技的产品与服务进行其他任何违法以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。
                </p>
            </div>
            <div class="title-item">隐私条款</div>
            <div class="cont">
                <p>
                    我们致力于保护您在使用把手科技的产品和服务时提供的个人信息，包括注册账户信息以及把手科技收集的用户自检记录等信息。您所提交的某些信息可能是个人身份验证信息
                    （即可辨明您个人身份的信息，例如您的姓名、职业、电话号码等），我们基于以下情形可能使用您的个人信息：
                </p>
                <p> （1）保证您正常使用“{{ $store.state.clientele.displayName }}”产品及服务； </p>
                <p>
                    （2）向您发送关于“{{
                        $store.state.clientele.displayName
                    }}”产品及服务的相关信息；
                </p>
                <p>（3）为您定制个性化产品需求和功能；</p>
                <p>（4）把手科技进行客户需求分析的需要；</p>
                <p>（5）把手科技进行产品功能维护或升级的需要；</p>
                <p>（6）其他为了提升把手科技的产品与服务质量的内部使用。</p>
                <p>
                    在以下情形，“{{
                        $store.state.clientele.displayName
                    }}”可能根据国家相关规定披露您的信息：
                </p>
                <p>
                    （1）您的行为违反了互联网相关法律法规的规定，或可能损害或妨碍其他用户的权益时，披露您的个人信息是为了辨识、联络或采取法律行动所必需时；
                </p>
                <p>（2）按法律规定或涉及司法或政府的调查而披露；</p>
                <p>（3）法律法规所规定的其他必须披露个人信息的情形。</p>
            </div>
            <div class="title-item">免责声明</div>
            <div class="cont">
                <p>
                    本{{
                        $store.state.clientele.displayName
                    }}中的自检报告结果均依据您进行自检问卷作答的内容自动生成，最终形成的报告中的企业风险评级以及相应的风险防范意见均取决于您填写的问卷内容。
                </p>
                <p>
                    您在使用把手科技的产品与服务时必须遵守国家有关法律和政策，并遵守本条款，对于用户违法或违反本协议的使用而引起的一切后果，把手科技不承担任何责任。
                </p>
                <p>
                    因本网站的的技术故障等不可预测事件影响到服务的正常运行，我们承诺尽快进行修复，但由于不可抗力、意外事件（包括但不限于计算机病毒感染、黑客攻击）导致用户信息被破坏、泄密并造成损失的，把手科技不承担任何法律责任。
                </p>
            </div>
            <div class="title-item">版权声明</div>
            <div class="cont">
                <p>
                    任何域名中包含“bashou.tech,lawsdata.com”的网站均属把手科技有限公司所有，并由把手科技有限公司负责运营。
                </p>
                <p>
                    本网站及其他由把手运营的法律类服务产品所有内容的版权归“把手”所有，受中华人民共和国版权法和中国缔结的版权公约、著作权公约的保护。
                </p>
                <p>
                    您不得以任何方式复制、翻印、再版、上传、转贴、传播或散发本网站以及其中任何的内容，包括但不限于设计、标志、配色方案、图形样式、文本、图片和视频等版权作品。
                </p>
                <p>
                    禁止提取本网站全部或大部分版权作品的行为，对版权作品进行修改或将其用于任何其他用途，均构成对版权所有人权利的侵犯，被严格禁止。
                </p>
                <p>
                    把手科技尊重并严格遵守版权法。同样地，“把手科技”也希望使用“本网站”的所有客户尊重并严格遵守版权法，共同营造良好的使用环境。
                </p>
            </div>
        </a-modal>

        <a-modal v-model="ipVisible" title="访问受限">
            <p>请于本省内进行访问</p>
            <p>申请暂时解除限制请联系</p>
            <p>0431-81884046</p>
            <template slot="footer">
                <a-button key="back" @click="outLogin">退出</a-button>
                <!-- <a-button key="submit" type="primary" :loading="loading" @click="apply">
          申请解除
        </a-button> -->
            </template>
        </a-modal>
    </div>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN' // 汉化
    import Identify from '../../components/Identify/Identify'
    import md5 from 'js-md5'

    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'
    import { REGEXP_NUMBER_END_LETTER, REGEXP_PHONE } from '@/utils/public/RegExp'

    const formItemLayout = {
        wrapperCol: { span: 24, offset: 0 },
    }
    export default {
        name: 'Register',
        data() {
            return {
                zhCN,
                formItemLayout,
                form: this.$form.createForm(this),
                identifyCode: '',
                identifyCodes: '1234567890',
                disabled: false,
                timer: null,
                regNumberEndLetter: REGEXP_NUMBER_END_LETTER,
                phoneValue: '',
                phoneOptions: [],
                checked: false,
                visible: false,
                ipVisible: false,
            }
        },
        components: {
            SIdentify: Identify,
        },
        computed: {
            isQQOrWeiXin() {
                return sessionStorage.getItem('QQOrWeiXin')
            },
            loginStatus() {
                return sessionStorage.getItem('loginStatus')
            },
        },
        mounted() {
            // console.log(sessionStorage.getItem('QQOrWeiXin'), '注册mounted', sessionStorage.getItem('login'), this.$store.state.isLogin,);
            this.identifyCode = ''
            this.makeCode(this.identifyCodes, 4)
            sessionStorage.getItem('loginStatus') == '2' && this.getLoginList()
            this.$store.commit('saveLicense', sessionStorage.getItem('license'))

            // // 搜狐第三方接口报错，导致returnCitySN获取不到值
            // window.returnCitySN = window.returnCitySN || {
            //   cip: "1.1.1.1",
            //   cid: "111111",
            //   cname: "错误地区",
            // };
            // this.$store.commit("saveIp", window.returnCitySN["cip"]);
            // this.$store.commit("saveAddress", window.returnCitySN["cname"]);
        },
        methods: {
            apply() {
                let that = this
                if (this.isQQOrWeiXin == '1') {
                    //手机号注册 用手机号解禁
                    let sendData = {
                        // ip: this.$store.state.ip,
                        license: this.$store.state.license,
                        phone: this.$refs.phone.value,
                    }
                    ajax(apiListPC.relieveIp, sendData, 'POST').then((res) => {
                        if (res) {
                            //注册成功以后 调登录接口 取回token
                            let data = {
                                phone: that.$refs.phone.value,
                                password: md5(that.$refs.password.value).toUpperCase(),
                                license: that.$store.state.license,
                                // ip: that.$store.state.ip,
                                // address: that.$store.state.address,
                            }
                            ajax(apiListPC.login, data, 'POST').then(function (data) {
                                that.$message.success('登录成功！')
                                localStorage.setItem('token', data.data.token)
                                //每次登录成功以后 将返回来的token存起来 在每次发起请求时 需要带上token作为校验信息
                                if (data.data.loginStatus == '1') {
                                    that.$router.replace('/Select')
                                }
                            })
                        }
                    })
                } else {
                    // 微信登录需要ip和token
                    let sendData = {
                        ip: this.$store.state.ip,
                        token: localStorage.getItem('token'),
                    }
                    ajax(apiListPC.relieveIp, sendData, 'POST').then((res) => {
                        if (res) {
                            this.$store.commit('changeLoginTrue')
                            this.$router.replace('/Select')
                        }
                    })
                }
            },
            outLogin() {
                this.ipVisible = false
                this.$router.replace('/Login')
            },
            check() {
                let that = this
                this.form.validateFields((err) => {
                    if (!err) {
                        if (!that.checked) {
                            that.$message.warning('请阅读并同意用户协议')
                            return false
                        }
                        // console.log(this.$store.state.license, 56464);
                        let sendData = {
                            username: '', //that.$refs.username.value
                            password: md5(that.$refs.password.value).toUpperCase(),
                            phone: that.$refs.phone.value,
                            license: that.$store.state.license,
                            // ip: that.$store.state.ip,
                            // address: that.$store.state.address,
                        }
                        // let res = register('registered?code='+that.$refs.phoneCode.value+'&inviteCode='+that.$refs.invitingCode.value,sendData,'POST');
                        ajax(
                            `${apiListPC.register}?code=${that.$refs.phoneCode.value}`,
                            sendData,
                            'POST'
                        )
                            .then(function (res) {
                                if (res.returnCode == 428) {
                                    that.ipVisible = true
                                    return false
                                }
                                //注册成功以后 调登录接口 取回token
                                let data = {
                                    phone: that.$refs.phone.value,
                                    password: md5(that.$refs.password.value).toUpperCase(),
                                    license: that.$store.state.license,
                                    // ip: that.$store.state.ip,
                                    // address: that.$store.state.address,
                                }
                                ajax(apiListPC.login, data, 'POST').then(function (data) {
                                    that.$message.success('登录成功！')
                                    localStorage.setItem('token', data.data.token)
                                    //每次登录成功以后 将返回来的token存起来 在每次发起请求时 需要带上token作为校验信息
                                    if (data.data.loginStatus == '1') {
                                        that.$router.replace('/Select')
                                    }
                                })
                            })
                            .catch(function (data) {
                                that.$message.error(data.returnInfo)
                            })
                    }
                })
            },
            getLoginList() {
                ajax(apiListPC.getLoginList, {}, 'POST')
                    .then((res = []) => {
                        this.phoneOptions = res.map((item) => ({
                            ...item,
                            value: item.userId,
                            label: `${item.phone} - ${item.nickname}`,
                        }))
                    })
                    .catch((err) => {
                        this.$message.error(err.returnInfo)
                    })
            },
            bindAndLogin() {
                let that = this
                this.form.validateFields((err) => {
                    if (!err) {
                        // console.log(sessionStorage.getItem('loginStatus'))
                        if (sessionStorage.getItem('loginStatus') == '0') {
                            let sendData = {
                                phone: that.$refs.phone.value,
                                license: that.$store.state.license,
                            }
                            const customConfig = {
                                headers: {
                                    Authentication: sessionStorage.getItem('tokenWeixin' || ''),
                                },
                            }
                            ajax(
                                `${apiListPC.WeChatSMSRegistr}?code=${that.$refs.phoneCode.value}`,
                                sendData,
                                'POST',
                                this,
                                customConfig
                            )
                                .then(function (res) {
                                    if (res.data.loginStatus == '1' && !!res.data.token) {
                                        that.$message.success('登录成功！')
                                        //每次登录成功以后 将返回来的token存起来 在每次发起请求时 需要带上token作为校验信息
                                        localStorage.setItem('token', res.data.token)
                                        sessionStorage.removeItem('tokenWeixin')
                                        that.$router.replace('/Select')
                                    }
                                    if (res.data.loginStatus == '3' && !!res.data.token) {
                                        //每次登录成功以后 将返回来的token存起来 在每次发起请求时 需要带上token作为校验信息
                                        localStorage.setItem('token', res.data.token)
                                        sessionStorage.removeItem('tokenWeixin')
                                        that.ipVisible = true
                                        // that.$router.replace("/Select");
                                    }
                                })
                                .catch(function (data) {
                                    that.$message.error(data.returnInfo)
                                })
                        }
                        if (sessionStorage.getItem('loginStatus') == '2') {
                            let sendData = {
                                userId: that.$refs.phone.value,
                                // ip: that.$store.state.ip,
                                // address: that.$store.state.address,
                            }
                            ajax(apiListPC.selectToLogin, sendData, 'POST')
                                .then(function (res) {
                                    if (res.loginStatus == '1' && !!res.token) {
                                        that.$message.success('登录成功！')
                                        localStorage.setItem('token', res.token)
                                        sessionStorage.removeItem('tokenWeixin')
                                        that.$router.replace('/Select')
                                    }
                                    if (res.loginStatus == '3' && !!res.token) {
                                        //每次登录成功以后 将返回来的token存起来 在每次发起请求时 需要带上token作为校验信息
                                        localStorage.setItem('token', res.token)
                                        sessionStorage.removeItem('tokenWeixin')
                                        that.ipVisible = true
                                        // that.$router.replace("/Select");
                                    }
                                })
                                .catch(function (data) {
                                    that.$message.error(data.returnInfo)
                                })
                        }
                    }
                })
            },
            toLogin() {
                sessionStorage.setItem('QQOrWeiXin', '1')
                this.$router.replace('/Login')
            },
            getPhoneCode(el) {
                //判断手机号
                let phone = this.$refs.phone.value
                let reg = REGEXP_PHONE
                if (!reg.test(phone)) {
                    this.$message.error('手机号格式错误')
                    return
                }
                //判断图形验证码是否正确
                if (this.$refs.picCode.value !== this.identifyCode) {
                    this.$message.error('图片验证码错误')
                    this.$refs.picCode.value = ''
                    return
                }
                let that = this
                const paramsData = { mobile: phone, license: that.$store.state.license }
                let res = ajax(apiListPC.getRegisterCaptcha, paramsData)
                res.then(function () {
                    that.disabled = true
                    let s = 60
                    that.timer = setInterval(function () {
                        el.target.innerText = s + '秒后重新获取'
                        s--
                        if (s == 0) {
                            that.disabled = false
                            el.target.innerText = '获取验证码'
                            clearInterval(that.timer)
                        }
                    }, 1000)
                }).catch(function (data) {
                    that.$message.error(data.returnInfo)
                })
            },
            getPhoneCodeWeiXin(el) {
                //判断手机号
                let phone = this.$refs.phone.value
                let reg = REGEXP_PHONE
                if (!reg.test(phone)) {
                    this.$message.error('手机号格式错误')
                    return
                }
                let that = this
                const paramsData = { mobile: phone, license: that.$store.state.license }
                let res = ajax(apiListPC.getRegisterCaptcha, paramsData)
                res.then(function () {
                    that.disabled = true
                    let s = 60
                    that.timer = setInterval(function () {
                        el.target.innerText = s + '秒后重新获取'
                        s--
                        if (s == 0) {
                            that.disabled = false
                            el.target.innerText = '获取验证码'
                            clearInterval(that.timer)
                        }
                    }, 1000)
                }).catch(function (data) {
                    that.$message.error(data.returnInfo)
                })
            },
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            refreshCode() {
                this.identifyCode = ''
                this.makeCode(this.identifyCodes, 4)
            },
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode +=
                        this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
                }
            },
            checkContent(rule, value, callBack) {
                if (value !== this.$refs.password.value) {
                    callBack('两次密码输入不一致')
                }
                callBack()
            },
            onChange(e) {
                this.checked = e.target.checked
            },
            showModal() {
                this.visible = true
            },
            handleOk() {
                this.visible = false
            },
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
    }
</script>

<style lang="less" type="text/less" scoped>
    .login-bg {
        width: 100%;
        height: 100vh;

        .login-left {
            width: 605px;
            height: 100%;
            background: url('../../../static/images/bg-4.jpg');
            float: left;
            position: relative;

            img {
                width: 50px;
                height: 50px;
                position: absolute;
                left: 40px;
                top: 40px;
            }

            .clienteleName {
                position: absolute;
                left: 100px;
                top: 40px;
                line-height: 50px;
                color: white;
                font-size: 24px;
            }

            .login-copyright {
                color: #fff;
                opacity: 0.4;
                font-size: 13px;
                text-align: left;
                text-indent: 40px;
                position: absolute;
                bottom: 30px;
                left: 0;
            }

            .login-info {
                width: 100%;
                height: 100px;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -40px;
                padding: 0 40px;
            }

            .login-info-title {
                text-align: left;
                height: 60px;
                line-height: 60px;
                font-size: 30px;
                font-weight: 500;
                color: #fff;
                span {
                    display: inline-block;
                    border: 1px solid #fff;
                    font-size: 14px;
                    color: #fff;
                    border-radius: 2px;
                    line-height: 18px;
                    padding: 0 3px;
                    margin-left: 10px;
                    position: relative;
                    top: -2px;
                }
            }

            .login-info-text {
                text-align: right;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                font-weight: 200;
                color: #fff;
            }
        }

        .login-right {
            width: calc(100% - 605px);
            height: 100%;
            float: right;
            position: relative;

            .login-box {
                width: 450px;
                height: 500px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -200px;
                margin-top: -250px;
                .ant-form-item {
                    margin-bottom: 12px;
                }
                .form-item {
                    position: relative;
                    button {
                        position: absolute;
                        right: 0;
                        top: -6px;
                    }
                    .identifyCode {
                        position: absolute;
                        right: 0;
                        top: -10px;
                    }
                }
                h2 {
                    text-align: center;
                    margin-bottom: 0;
                    height: 50px;
                    line-height: 50px;
                    font-weight: 700;
                    letter-spacing: 8px;
                }

                .my-btn {
                    border-radius: 15px;
                    width: 45%;
                    display: inline-block;
                    float: left;
                }

                .fr {
                    float: right;
                }

                .border-bottom {
                    border: none;
                    border-bottom: 1px solid #ddd;
                    border-radius: 0;
                }

                .margin-top-30 {
                    margin-top: 30px;
                }
            }
        }
    }
    /deep/.ant-modal-body {
        max-height: 600px;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            background-color: #e7e7e7;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: @primary-color;
        }
    }
</style>
